module.exports = __webpack_public_path__ + "static/media/square-network-img.52c14672.svg";